/**
 * Possible values that a lambda's FunctionError field can return when a lambda's invocation has failed.
 *
 * As part of extracting this constant to a shared place so it can be reused across our lambda invokers,
 * I tried to find exactly what the "Handled" and "Unhandled" values represent in the node.js SDK so I could document
 * them here, but could not find any docs on the AWS site.
 */
export const LAMBDA_FUNCTION_ERROR_VALUES = ['Handled', 'Unhandled'];
export const ONE_SECOND_MS = 1000;
export const TWO_SECONDS_MS = 2000;
export const TEN_SECONDS_MS = 10000;
export const ONE_MINUTE_MS = 60000;
export const TWO_MINUTES_MS = 120000;
export const FIVE_MINUTES_MS = 300000;
export const ONE_HOUR_MS = 3600000;
